import { ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";

export type ProductDto = ClientInferResponseBody<typeof contract.products.findAll, 200>[number];

export const fetchProducts = async (): Promise<ProductDto[]> => {
  const response = await api.products.findAll.query();

  if (response.status === 200) {
    return response.body;
  }

  return [];
};
